export var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    // Brian added this in 06/2021 expected to be removed in 10/2021
    FeatureFlagEnum["RELEASE_GATE_IMS"] = "release-gate-ims";
    // Brittany added this in 07/2021 expected to be removed in 10/2021
    FeatureFlagEnum["RELEASE_GATE_TACTICAL_MAPS"] = "release-gate.tactical-maps";
    // Nathan added this on 12/15/2021 expected to be remove in 02/2022
    FeatureFlagEnum["RELEASE_GATE_COINTAINERS"] = "release-gate-cointainers";
})(FeatureFlagEnum || (FeatureFlagEnum = {}));
export const FEATURE_FLAG_LIST = [
    FeatureFlagEnum.RELEASE_GATE_IMS,
    FeatureFlagEnum.RELEASE_GATE_TACTICAL_MAPS,
    FeatureFlagEnum.RELEASE_GATE_COINTAINERS,
];
export const DEFAULT_FEATURE_FLAG_INFO = {
    [FeatureFlagEnum.RELEASE_GATE_IMS]: false,
    [FeatureFlagEnum.RELEASE_GATE_TACTICAL_MAPS]: false,
    [FeatureFlagEnum.RELEASE_GATE_COINTAINERS]: false,
};
